import {AxiosRequestConfig} from 'axios';
import {AccountOrganizationService} from './account-organization.service';
import Logger from '../../logger';
import {AccountOrganization} from '../../models/organization.model';
import {getAuthToken} from '../../utils';
import {APIServiceImpl} from '../api';
import {AccountOrganizationCreateParams} from './account-organization-params';

export class AccountOrganizationServiceImpl extends APIServiceImpl implements AccountOrganizationService {
  static readonly CREATE_ACCOUNT_ORGANIZATION = '/accounts/:accountId/organizations/:organizationId';

  constructor() {
    super();
    this.service.interceptors.request.use((request): AxiosRequestConfig => {
      const token = getAuthToken();
      token && (request.headers.Authorization = `Bearer ${token}`);
      return request;
    });
  }

  async createAccountOrganization(params: AccountOrganizationCreateParams): Promise<AccountOrganization> {
    const url = AccountOrganizationServiceImpl.CREATE_ACCOUNT_ORGANIZATION.replace(':accountId', params.accountId).replace(
      ':organizationId',
      params.organizationId,
    );

    try {
      const {data: res} = await this.post(url, {
        role: params.role,
      });
      return new AccountOrganization(res);
    } catch (e) {
      const error = e.response?.data?.message || e.message || e.response?.status;
      Logger.error(`POST ${url} ${JSON.stringify(params)}: ${e.toString()}: ${error}`);
      throw new Error(error);
    }
  }
}
